"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvestmentTile = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = _interopRequireDefault(require("./index.styled"));

var _IconLibrary = require("../IconLibrary");

var _Button = require("../Button");

var _PrivatePlacementDetails = require("./PrivatePlacementDetails");

var _ReitDetails = require("./ReitDetails");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var FundingBar = function FundingBar(_ref) {
  var percentage = _ref.percentage;
  return /*#__PURE__*/_react.default.createElement(_index.default.FundingBar, {
    percentage: percentage * 100
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "bar-background"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "progress-bar"
  })), /*#__PURE__*/_react.default.createElement("div", {
    id: "percentage-text"
  }, Math.floor(percentage * 100), "% FUNDED"));
};

var InvestmentTile = function InvestmentTile(_ref2) {
  var title = _ref2.title,
      image = _ref2.image,
      REIT = _ref2.REIT,
      id = _ref2.id,
      statusLabel = _ref2.statusLabel,
      propertyLocation = _ref2.propertyLocation,
      sponsorName = _ref2.sponsorName,
      targetReturn = _ref2.targetReturn,
      estimatedCashOnCashLow = _ref2.estimatedCashOnCashLow,
      targetEquityMultiple = _ref2.targetEquityMultiple,
      targetHoldMin = _ref2.targetHoldMin,
      minimum = _ref2.minimum,
      propertyType = _ref2.propertyType,
      declaredDividendRateAnnualized = _ref2.declaredDividendRateAnnualized,
      payoutLabel = _ref2.payoutLabel,
      progressBar = _ref2.progressBar,
      reitAssetValue = _ref2.reitAssetValue,
      _ref2$blurb = _ref2.blurb,
      blurb = _ref2$blurb === void 0 ? '' : _ref2$blurb,
      _ref2$watchlist = _ref2.watchlist,
      watchlist = _ref2$watchlist === void 0 ? {} : _ref2$watchlist,
      _ref2$watchlistCallba = _ref2.watchlistCallback,
      watchlistCallback = _ref2$watchlistCallba === void 0 ? function () {} : _ref2$watchlistCallba,
      _ref2$isLoggedIn = _ref2.isLoggedIn,
      isLoggedIn = _ref2$isLoggedIn === void 0 ? false : _ref2$isLoggedIn,
      distributionTooltip = _ref2.distributionTooltip,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'current' : _ref2$type,
      investmentTypeDisplay = _ref2.investmentTypeDisplay,
      actualHold = _ref2.actualHold,
      actualIRR = _ref2.actualIRR,
      IRRObjective = _ref2.IRRObjective,
      investmentStrategy = _ref2.investmentStrategy,
      returnOnCost = _ref2.returnOnCost;

  var _useState = (0, _react.useState)(watchlist.flagged),
      _useState2 = _slicedToArray(_useState, 2),
      flagged = _useState2[0],
      setFlagged = _useState2[1];

  var handleWatchListClick = function handleWatchListClick(e) {
    e.preventDefault();
    watchlistCallback(flagged, watchlist);
    setFlagged(function (flagged) {
      return !flagged;
    });
  };

  var isPastFunded = (statusLabel === null || statusLabel === void 0 ? void 0 : statusLabel.toLowerCase()) === 'funded';
  return type === 'current' ? /*#__PURE__*/_react.default.createElement(_index.default.InvestmentTile, {
    "data-id": id
  }, /*#__PURE__*/_react.default.createElement(_index.default.TileHero, {
    backgroundImage: image
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "background-mask"
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: "status"
  }, statusLabel), !REIT ? /*#__PURE__*/_react.default.createElement("div", {
    id: "heart-icon",
    onClick: isLoggedIn ? handleWatchListClick : null
  }, /*#__PURE__*/_react.default.createElement(_IconLibrary.Heart, {
    fill: flagged ? '#176DB6' : '#FFFFFF66',
    clicked: flagged
  })) : null, /*#__PURE__*/_react.default.createElement("div", {
    id: "info-copy"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    id: "title",
    title: title
  }, title), !REIT && /*#__PURE__*/_react.default.createElement("div", {
    id: "location"
  }, propertyLocation)), progressBar && progressBar.percent >= 0.7 && /*#__PURE__*/_react.default.createElement(FundingBar, {
    percentage: progressBar.percent
  }))), /*#__PURE__*/_react.default.createElement(_index.default.InfoSection, null, /*#__PURE__*/_react.default.createElement(_index.default.OfferText, {
    "data-test": "offer-text"
  }, REIT ? 'REIT TARGETS' : "OFFERED BY ".concat(sponsorName)), REIT ? /*#__PURE__*/_react.default.createElement(_ReitDetails.ReitDetails, {
    declaredDividendRateAnnualized: declaredDividendRateAnnualized,
    distributionFrequency: payoutLabel,
    totalAssetValue: reitAssetValue,
    minimum: minimum,
    distributionTooltip: distributionTooltip
  }) : /*#__PURE__*/_react.default.createElement(_PrivatePlacementDetails.PrivatePlacementDetails, {
    targetReturn: targetReturn,
    cashOnCash: estimatedCashOnCashLow * 100,
    returnOnCost: returnOnCost * 100,
    targetEquityMultiple: targetEquityMultiple,
    targetHoldMin: targetHoldMin,
    minimum: minimum,
    propertyType: propertyType
  }), /*#__PURE__*/_react.default.createElement(_index.default.DescriptionText, null, blurb.substr(0, 65), "...", /*#__PURE__*/_react.default.createElement(_index.default.MoreButton, null, " MORE \u25B6"))), /*#__PURE__*/_react.default.createElement(_index.default.ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    id: id
  }, REIT ? 'VIEW REIT' : 'VIEW PROPERTY'))) : /*#__PURE__*/_react.default.createElement(_index.default.InvestmentTile, {
    "data-id": id
  }, /*#__PURE__*/_react.default.createElement(_index.default.TileHero, {
    backgroundImage: image
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "background-mask"
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: "status"
  }, statusLabel), /*#__PURE__*/_react.default.createElement("div", {
    id: "info-copy"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    id: "title",
    title: title
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    id: "location"
  }, propertyLocation)))), /*#__PURE__*/_react.default.createElement(_index.default.TypeSection, null, /*#__PURE__*/_react.default.createElement("span", null, propertyType), /*#__PURE__*/_react.default.createElement("span", {
    class: "h-spacer"
  }), /*#__PURE__*/_react.default.createElement("span", null, investmentStrategy)), /*#__PURE__*/_react.default.createElement(_index.default.PastInfoSection, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label bold"
  }, "Actual IRR"), isPastFunded ? /*#__PURE__*/_react.default.createElement("span", {
    className: "funded-label"
  }, "Determined at Close") : /*#__PURE__*/_react.default.createElement("span", {
    className: "value bold"
  }, (actualIRR * 100).toFixed(1), "%")), /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Target*"), /*#__PURE__*/_react.default.createElement("span", {
    className: "value"
  }, IRRObjective ? "".concat((IRRObjective * 100).toFixed(1), "%") : '-')), /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label bold"
  }, "Actual Hold Period"), isPastFunded ? /*#__PURE__*/_react.default.createElement("span", {
    className: "funded-label"
  }, "Determined at Close") : /*#__PURE__*/_react.default.createElement("span", {
    className: "value bold"
  }, (actualHold / 12).toFixed(1), " Years")), /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Target*"), /*#__PURE__*/_react.default.createElement("span", {
    className: "value"
  }, (targetHoldMin / 12).toFixed(1), " Years"))));
}; // InvestmentTile.propTypes = {
//   /**
//    * Default width is 100%, override with this prop (eg: '250px')
//    **/
//   width: PropTypes.string,
//   /**
//    * Button label
//    **/
//   children: PropTypes.string,
//   /**
//    * set to 'submit' for form submission buttons
//    **/
//   type: PropTypes.string,
//   /**
//    * Style of button
//    */
//   styleType: PropTypes.oneOf(['Primary', 'Secondary']),
//   /**
//    * set href to make an A tag instead of a button
//    */
//   href: PropTypes.string,
//   /**
//    * overwrite to control link behavior
//    */
//   target: PropTypes.string,
// }


exports.InvestmentTile = InvestmentTile;